import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { ReportScheduleDialog } from "../Ui/Dialogs/ReportScheduleDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandReportScheduleReportPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandReportScheduleReportProperties = {
    [name in keyof EntityCommandReportScheduleReportPropertyValues]: Property<EntityCommandReportScheduleReportPropertyValues[name]>
};

export interface IEntityCommandReportScheduleReport extends IEntityCommand, EntityCommandReportScheduleReportProperties
{
}

export class EntityCommandReportScheduleReport extends EntityCommand implements IEntityCommandReportScheduleReport
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandReportScheduleReport";
    public static override className = "EntityCommandReportScheduleReport";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandReportScheduleReportPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Schedule Report",
                entityName: "Report",
                key: "SCHEDULE_REPORT",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandReportScheduleReportPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller)
                        return;

                    if (!caller.reportScheduleDialog)
                        caller.reportScheduleDialog = new ReportScheduleDialog();

                    return (
                        (caller.reportScheduleDialog as ReportScheduleDialog).openAsync(recordId)
                            .then(result =>
                            {
                                if (result.dialogResult !== DialogResultEnum.ok)
                                    return;

                                return (
                                    ServiceManager.getRequired(WebApiClientService)
                                        .createApiMethodRequest("DataService", "CallDataService", { id: "5912537e-4a2f-4dc0-a0a4-ec4159a7f8d3", operation: "ScheduleReport", data: ObjectHelper.toJson(result.promiseData) })
                                        .executeAsync()
                                        .then(() =>
                                        {
                                            return MessageDialog.displayMessage("Report scheduled", "Your report has been scheduled.");
                                        })
                                );
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

